import Http from '../utilities/http';

export class PhotoCategoryApi {
  static getAll(vehicleId) {
    return Http.get('/photo-category', {
      vehicleId,
    })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  }

  static create(data) {
    return Http.post('/photo-category', data)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  }

  static update(id, data) {
    return Http.patch(`/photo-category/${id}`, data)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  }

  static delete(id) {
    return Http.delete(`/photo-category/${id}`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  }
}
